import React from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";

// Sets the browser tab title (WCAG 2.4.2). Helmet keeps the innermost title,
// so a nested view can override the title of the view around it.
const DocumentTitle = ({ title }) => {
  if (typeof title !== "string" || title.trim() === "") {
    return null;
  }

  return (
    <Helmet>
      <title>{`${title} – Topaasia`}</title>
    </Helmet>
  );
};

DocumentTitle.propTypes = {
  title: PropTypes.string,
};

export default DocumentTitle;
